import { BuyPhoneNumber } from "../BuyPhoneNumber";

export const PhoneNumber = () => {
  return (
    <>
      <div className="flex-1">
        <BuyPhoneNumber />
      </div>
    </>
  );
};
